export class ProgramApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPrograms(params) {
    return this.#http.get('/api/programs', { params });
  }

  async createProgramV2(body) {
    return this.#http.post('/api/programs/v2', body);
  }

  async editProgramV2({ programId, ...body }) {
    return this.#http.put(`/api/programs/${programId}/v2`, body);
  }

  async deleteProgram({ programId }) {
    return this.#http.delete(`/api/programs/${programId}`);
  }

  async activateProgram({ programId }) {
    return this.#http.put(`/api/programs/${programId}/activate`);
  }
}
